module.exports = __webpack_public_path__ + "images/7d8d0a852cdb6abcaf414acdd6018783.ttf";


//////////////////
// WEBPACK FOOTER
// ./app/assets/fonts/EastSyriacQasha.ttf
// module id = 1150
// module chunks = 0